module.exports = __webpack_public_path__ + "img/hired.01769b33.svg";